import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Moment from "moment";
import { DisplaySmall, Title, Body, spacing } from "@conserveit/blocks";
import { jobStates } from "../../redux/modules/reportGenerator";

const PanelWrapper = styled.div`
  margin-top: ${spacing.extraLoose};
  min-width: 280px;
`;
const RowWrapper = styled.div`
  margin: ${spacing.default} 0;
  > ${Title}, > ${Body} {
    display: inline-block;
  }

  & ${Title} {
    margin-right: ${spacing.tight};
  }
`;

const ReportJobStatusPanel = ({
  jobId,
  jobStart,
  jobMsg,
  jobState,
  jobProgress,
}) => {
  let panelHeading = "";

  switch (jobState) {
    case jobStates.RUNNING:
      panelHeading = "Running Report";
      break;
    case jobStates.DONE_OK:
      panelHeading = "Success";
      break;
    case jobStates.DONE_ERROR:
      panelHeading = "Report Failed";
      break;
    case jobStates.CANCELLING:
    case jobStates.DONE_CANCEL:
      panelHeading = "Report Cancelled";
      break;
    default:
      throw new Error("Job Status not found");
  }

  return (
    <PanelWrapper>
      <DisplaySmall>{panelHeading}</DisplaySmall>

      {jobId ? (
        <RowWrapper>
          <Title>Job Id:</Title>
          <Body>{jobId}</Body>
        </RowWrapper>
      ) : null}
      {jobStart ? (
        <RowWrapper>
          <Title>Started:</Title>
          <Body>{Moment(jobStart).format("h:mm a")}</Body>
        </RowWrapper>
      ) : null}
      {jobMsg ? (
        <RowWrapper>
          <Title>Status:</Title>
          <Body>{jobMsg}</Body>
        </RowWrapper>
      ) : null}
      {jobProgress && parseInt(jobProgress, 10) > 0 ? (
        <RowWrapper>
          <Title>Progress:</Title>
          <Body>{jobProgress}</Body>
        </RowWrapper>
      ) : null}
    </PanelWrapper>
  );
};

ReportJobStatusPanel.defaultProps = {
  jobId: "",
  jobStart: "",
  jobMsg: "",
  jobProgress: "",
};

ReportJobStatusPanel.propTypes = {
  jobState: PropTypes.string.isRequired,
  jobId: PropTypes.string,
  jobStart: PropTypes.string,
  jobMsg: PropTypes.string,
  jobProgress: PropTypes.string,
};

export default ReportJobStatusPanel;
